/* eslint-disable import/prefer-default-export */

import { Logger } from '../../services';

type ImpactLevel = 'low' | 'medium' | 'high';

/**
 * Normalizes impact level from API response to component-expected format
 * Returns undefined for invalid/missing data to avoid showing incorrect information
 *
 * @param impact - Impact level string from API
 * @returns Normalized impact level or undefined if invalid
 */
export const normalizeImpactLevel = (
  impact: string | undefined
): ImpactLevel | undefined => {
  if (!impact) {
    return undefined;
  }

  const normalized = impact.toLowerCase();

  if (
    normalized === 'high' ||
    normalized === 'medium' ||
    normalized === 'low'
  ) {
    return normalized as ImpactLevel;
  }

  Logger.warn('Invalid impact level received from API:', impact);

  return undefined;
};
